import React, {memo} from "react";

const randomSpeed = () => [2, 3, 4, 5][Math.floor(Math.random() * 4)]

const FlyingEmoji = ({animated, left, top, emoji}) => {
    return (<div className={`react-icon-${emoji}`} style={{
        top, left,
        position: 'absolute',
        transition: animated ? `top ${randomSpeed()}s, left ${randomSpeed()}s` : 'inherit',
        // backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: 60,
        height: 60
    }}/>);
}

export default memo(FlyingEmoji)